import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import actions from '../actions';
import { React } from '../common';
import {
    getDoctorBiIdFirstCallDate,
    getFlatDoctorsDataWithSpecialities,
    getPureSpecialitiesFullList,
} from '../selectors';

export const useDoctorApi = ({
    id = '',
    withAssignments = false,
    nullWithoutAssignment = true,
    fullName,
    specialization,
}) => {
    const [ doctor, setDoctor ] = React.useState(id);
    const [ wasLoaded, setWasLoaded ] = React.useState(false);
    const doctors = useSelector(getFlatDoctorsDataWithSpecialities);
    const callTime = useSelector(getDoctorBiIdFirstCallDate);
    const specialitiesList = useSelector(getPureSpecialitiesFullList);

    useEffect(() => {
        if (!callTime && wasLoaded) {
            setWasLoaded(false);
        }
    }, [ callTime ]);
    
    // Reset wasLoaded when id changes
    useEffect(() => {
        setWasLoaded(false);
    }, [ id ]);
    
    const resetLoaded = () => setWasLoaded(false);
    useEffect(() => {
        if (id && specialitiesList) {
            if (nullWithoutAssignment) {
                if (doctors?.[id] && (doctors?.[id]?.assignments?.length || !withAssignments)) {
                    setDoctor(doctors[id]);
                } else {
                    if (!wasLoaded) {
                        const specializationId = specialitiesList?.find(e=> e?.name === specialization)?.id;
                        actions.loadDoctorInfo(id, withAssignments, fullName, specializationId);
                        setWasLoaded(true);
                    } else {
                        setDoctor(null);
                    }
                }
            } else {
                if (doctors?.[id]) {
                    setDoctor(doctors[id]);
                    if (!doctors?.[id]?.assignments?.length && withAssignments && !wasLoaded) {
                        const specializationId = specialitiesList?.find(e=> e?.name === specialization)?.id;
                        actions.loadDoctorInfo(id, withAssignments, fullName, specializationId);
                        setWasLoaded(true);
                    }
                }
            }
        }
    }, [ id,
        doctors,
        nullWithoutAssignment,
        withAssignments,
        wasLoaded,
        fullName,
        specialization,
        specialitiesList ]);

    return {
        doctors,
        doctor,
        resetLoaded,
    };
};
